import EmailHTMLWarning from './EmailHTMLWarning';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterInfoWarnings = props => {
  const {
    condition,
    use = 'warning'
  } = props;

  /**
   * @temporary EmailHTMLWarning will not be necessary once `hs_email_html` is backfilled
   * @expiration 2025-06-30
   * @deprecated
   */
  return /*#__PURE__*/_jsx(EmailHTMLWarning, {
    condition: condition,
    use: use
  });
};
export default FilterInfoWarnings;